import tw, { css } from 'twin.macro'

const stylesBase = css`
  a {
    ${tw`text-red-500 hover:text-red-600`}
  }
`

export default stylesBase
